import styled, { css } from 'styled-components';

export const FiltersWrapper = styled.div`
  margin-block: 24px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 24px;

  #filter-groups {
    order: 1;
  }

  #filter-ffoo {
    order: 2;
  }

  #filter-user_work_role {
    order: 3;
  }

  #filter-regions {
    order: 4;
  }

  #filter-provinces {
    order: 5;
  }

  #filter-time-interval {
    order: 6;
  }
  #search-cta {
    order: 7;
  }
`;

export const SortingWrapper = styled.div`
  margin-block: 24px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;

  > div {
    height: 48px;
  }

  .info {
    color: ${({ theme }) => theme.colors.textSecondary};
    svg {
      stroke: ${({ theme }) => theme.colors.textSecondary} !important;
      margin-right: 8px;
    }
  }
`;

const gridTableCol = css`
  --padding-inline: 24px;

  display: grid;
  grid-template-columns: repeat(2, 1fr) 1.5fr repeat(3, 1fr) 100px;
  gap: 24px;
  padding-inline: var(--padding-inline);
`;

export const Legend = styled.div`
  ${gridTableCol}
  margin-bottom: 24px;
  align-items: center;

  > *:first-child {
    margin-left: calc(var(--padding-inline) * -1);
  }

  > *:last-child {
    margin-right: calc(var(--padding-inline) * -1);
  }
`;

export const CardsWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => !['hasPaginator'].includes(prop),
})`
  padding-bottom: ${({ hasPaginator }) => (hasPaginator ? 48 : 64)}px;

  > div:last-child {
    margin-bottom: 0;
  }
`;

export const UserCard = styled.div`
  ${gridTableCol}
  align-items: end;
  padding-block: 38px;
  margin-bottom: 16px;
  height: 100px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);

  > *:last-child {
    margin-left: auto;
  }
`;

export const CompletionWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;

  svg {
    margin-top: -4px; //center to text
  }
`;
